import { EditorState, LexicalEditor } from 'lexical';
import { LexicalOnChangeCTA } from 'modules/Lexical/hooks/useLexicalCallToActionEditor';
import { HistoryPluginChangeHandler } from 'modules/Lexical/Plugins/HistoryWithExtraStatePlugin';
import React, { createContext, ReactNode, useContext } from 'react';
import { IList } from 'typings/DeepIMap';
import { BrandColor, BrandFont } from 'models';
import { HistoryExtraStateHook } from '../hooks/useHistoryExtraState';

type ContextType = {
  editorState: string | null;
  editorRef: React.RefObject<LexicalEditor>;
  onChange: LexicalOnChangeCTA;
  onStopEditing: (state: EditorState) => void;
  id: string;
  cssButton: string;
  editMode: boolean;
  editorWrap: React.RefObject<HTMLDivElement>;
  returnFocusToEditor: () => void;
  styles: React.CSSProperties;
  brandProps: {
    colors: IList<BrandColor>;
    fonts: IList<BrandFont>;
  };
  history: HistoryExtraStateHook;
  historyOnChange: HistoryPluginChangeHandler;
};

const Context = createContext<ContextType | null>(null);

export const useLexicalCTAEditorContext = (): ContextType => {
  const value = useContext(Context);

  if (!value) {
    throw new Error('must be used within a LexicalCTAEditorProvider');
  }

  return value;
};

type ProviderProps = {
  value: ContextType;
  children: ReactNode;
};

export const LexicalCTAEditorProvider: React.FC<ProviderProps> = ({ children, value }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
